import { css } from 'styled-components';
export var flag = /*#__PURE__*/css(["aspect-ratio:1.49;"]);